<kendo-dialog tid="alert_window" *ngIf="open" (mousedown)="onClickSetEventValue($event)"
    (click)="onClickSetEventValue($event)" (close)="close(event)" [minWidth]="410">
    <div class="alert-title">
        <div class="inlineb alert-title-icon-section">
            <smart-icon name='info' class="alert-title-icon"></smart-icon>
        </div>
        <div class="inlineb alert-title-content">
            <span *ngIf="deleteOneRelationship">Delete Relationship</span>
            <span *ngIf="deleteMultiRelationship">Delete Relationship(s)</span>
        </div>
    </div>

    <!-- focus on an entity -->
    <div *ngIf="isEntityRootNode">
        <!-- remove contact item -->
        <div class="alert-body" tid="alert_body" *ngIf="deleteOneRelationship && isContactParent">
            <p class="alert-content" *ngIf="deleteOneRelationship">Remove {{currentClickedRelNodeName}} from
                {{topNodeName}}'s contact list?
            </p>
        </div>
        <!-- remove entity item -->
        <div class="alert-body" tid="alert_body" *ngIf="deleteOneRelationship && !isContactParent">
            <p class="alert-content">Delete the '{{topNodeName}}
                {{currentClickedItemRelTypeName}} {{currentClickedRelNodeName}}'
                relationship?
            </p>
            <label class="checkbox-del-reciprocal" tam-checkbox [(ngModel)]="isDeleteReciprocalRel">
                Also delete reciprocal relationships
            </label>
        </div>
        <!-- remove contact parent -->
        <div class="alert-body" tid="alert_body" *ngIf="deleteMultiRelationship && isContactParent">
            <p class="alert-content">
                Remove all of the '{{currentClickedRelTypeNodeName}}' contacts from {{topNodeName}}'s contact list?
            </p>
        </div>
        <!-- remove entity parent -->
        <div class="alert-body" tid="alert_body" *ngIf="deleteMultiRelationship && !isContactParent">
            <p class="alert-content">Delete all of {{topNodeName}}'s
                '{{currentClickedRelTypeNodeName}}' relationships?
            </p>
            <label class="checkbox-del-reciprocal" tam-checkbox [(ngModel)]="isDeleteReciprocalRel">
                Also delete reciprocal relationships
            </label>
        </div>
    </div>

    <!-- focus on a contact -->
    <div *ngIf="!isEntityRootNode">
        <!-- remove entity item -->
        <div class="alert-body" tid="alert_body" *ngIf="deleteOneRelationship && !isContactParent">
            <p class="alert-content">Remove {{currentClickedRelNodeName}} from {{topNodeName}}'s entity list?
            </p>
        </div>
        <!-- remove contact item -->
        <div class="alert-body" tid="alert_body" *ngIf="deleteOneRelationship && isContactParent">
            <p class="alert-content">Remove {{currentClickedRelNodeName}} from {{topNodeName}}'s contact list?
            </p>
        </div>
        <!-- remove entity parent -->
        <div class="alert-body" tid="alert_body" *ngIf="deleteMultiRelationship && !isContactParent">
            <p class="alert-content">Delete all of {{topNodeName}}'s
                '{{currentClickedRelTypeNodeName}}' entities?
            </p>
        </div>
        <!-- remove contact parent -->
        <div class="alert-body" tid="alert_body" *ngIf="deleteMultiRelationship && isContactParent">
            <p class="alert-content">Delete all of {{topNodeName}}'s
                '{{currentClickedRelTypeNodeName}}' contacts?
            </p>
        </div>
    </div>

    <div class="alert-button">
        <button class="alert-close" tam-button tid="cancel_button" [tamType]="'tertiary'" [tamSize]="'normal'"
            (click)="close($event)">Cancel</button>
        <button class="fix-button" tam-button tid="confirm_button" [tamType]="'destructive'" [tamSize]="'normal'"
            (click)="delete($event)">Delete</button>
    </div>
</kendo-dialog>